import React from "react";

const Warning = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M2 28.008v1.002c.02.07.046.137.058.206.175 1.064.64 1.977 1.422 2.72.965.917 2.126 1.288 3.444 1.286 7.384-.01 14.767-.005 22.15-.005.177 0 .355 0 .531-.014 1.722-.136 3.019-.964 3.829-2.483.832-1.562.71-3.117-.129-4.66-3.74-6.872-7.467-13.752-11.203-20.627a4.399 4.399 0 00-1.453-1.609c-2.417-1.585-5.437-.817-6.82 1.732-3.441 6.337-6.883 12.672-10.316 19.011C2.914 25.672 2.205 26.73 2 28.008zm17.875-10.783v.908c0 1.252.01 2.503-.003 3.755-.014 1.36-1.237 2.251-2.483 1.826-.787-.269-1.262-.97-1.263-1.889-.002-3.046-.002-6.09 0-9.137 0-.156.01-.314.039-.466a1.85 1.85 0 012.099-1.519c.946.13 1.603.904 1.609 1.923.008 1.532.002 3.066.002 4.6zM18 29.455a1.88 1.88 0 01-1.872-1.863 1.898 1.898 0 011.858-1.886c1.017-.017 1.893.86 1.888 1.887a1.879 1.879 0 01-1.874 1.863z"
            fill={fill}
        />
    </svg>
);

export default Warning;
